import React, { useContext, useEffect, useState } from "react";
import { LoaderOnly } from "../../../atoms/Loader/Loader";
import styles from "./ReportProblemPopup.module.scss";
import { UserContext } from "../../../../contexts/UserContext";
import { languages } from "../../../../dummyData/dummyData";
import Text from "../../../atoms/Text/Text";
import { ReportProblemContext } from "../../../../contexts/ReportProblemContext";

const ReportProblemPopup = () => {
  const [scriptLoaded, setLoaded] = useState(false);
  const [frameLoaded, setFrameLoaded] = useState(false);
  const { userData } = useContext(UserContext);
  const { getSubject } = useContext(ReportProblemContext);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
    script.addEventListener("load", () => setLoaded(true))
    document.body.appendChild(script);
  }, []);

  const searchParams = new URLSearchParams();
  searchParams.append("Subject", getSubject());
  searchParams.append("Name", userData ? userData.name : 'Guest');
  searchParams.append("Email", userData ? userData.email : '-');
  searchParams.append("Username", userData ? userData.username : '-');
  searchParams.append("URL", window.location.href);
  searchParams.append("User Agent", navigator.userAgent);
  searchParams.append("Resolution", window.screen.width + 'x' + window.screen.height);

  return scriptLoaded && (
    <>
      <Text>{languages.EN.labels.reportProblem} / {languages.EN.labels.askQuestion}</Text>
      <iframe
        className={styles.form}
        src={`https://forms.clickup.com/3707147/f/3h48b-7248/9UPYY4W0HFZALKKTAC?${searchParams.toString()}`}
        onLoad={() => setFrameLoaded(true)}
      />
      {!frameLoaded && (
        <div className={styles.loaderWrapper}>
          <LoaderOnly size={25} />
        </div>
      )}
    </>
  );
};

export default ReportProblemPopup
